import React, { useState, useEffect, useRef } from "react";
//import "rsuite/dist/rsuite.min.css";
import { Form } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import AuthService from "../../../services/auth.service";
import Modal from "react-bootstrap/Modal";
import check from "../../../picture/check.png";
import Select from "react-select";
import { color, style } from "@mui/system";
import "./Styles.css";
function EditRegisDrone() {
  let Navigate = useNavigate();
  function editdrone() {
    //setDisabless(false);
    Navigate("/editprofileuser", {
      state: {
        href: window.location.href,
      },
    });
  }
  const prevent = () => {
    Navigate("/checksora", {
      state: {
        post_id: true,
      },
    });
  };
  const myStyle = {
    paddingTop: "60px",
  };
  const myStyle1 = {
    paddingTop: "30px",
    color: "#0077B6",
  };
  const form1 = useRef();
  const [checkuserdata, setcheckuserdata] = useState(false);
  const [validated, setValidated] = useState(false);
  const [data, setData] = useState("");
  const [show, setShow] = useState(false);
  const [senddata, setSenddata] = useState(false);
  const [updatedata, setUpdatedata] = useState(false);
  const [updatedatasuc, setUpdatedatasuc] = useState(false);
  const [docsave, setDocsave] = useState(false);
  const [install_eq, setInstall_eq] = useState("-");
  const [remote_sn, setRemote_sn] = useState(false);
  const [remote_brand, setRemote_brand] = useState(false);
  const [ins_type, setIns_type] = useState(false);
  const [ins_number, setIns_number] = useState(false);
  const [ins_company_name, setIns_company_name] = useState(false);
  const [ins_limit, setIns_limit] = useState(false);
  const [ins_start, setIns_start] = useState(false);
  const [ins_end, setIns_end] = useState(false);
  const [model, setModel] = useState("GGGG"); ///mockup
  const [droneserial, setDroneserial] = useState(""); ///mockup
  const [brand, setBrand] = useState("TOYO"); ///mockup
  const [disabless, setDisabless] = useState(true);
  const handleClose = () => {
    setShow(false);
    setSenddata(false);
    setUpdatedata(false);
    setUpdatedatasuc(false);
    setcheckuserdata(false);
  };
  const handleSend = (e) => {
    console.log(form1.current.checkValidity());

    if (form1.current.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      e.preventDefault();
      setShow(true);
    }
    setValidated(true);
  };
  const handleSendsuc = () => {
    setDocsave(false);
    setShow(false);
    setSenddata(true);

    register(false);
  };
  const handleUpdate = (e) => {
    //console.log(form1.current.checkValidity());
    //console.log(typeof(ins_limit))
    if (form1.current.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      e.preventDefault();
      
      setUpdatedata(true);
    }

    setValidated(true);
  };
  const handleUpdatesuc = (e) => {
    e.preventDefault();
    setUpdatedata(false);
    setUpdatedatasuc(true);
    setDocsave(true);
    register(true);
  };
  const next = () => {
    setShow(false);
    setSenddata(false);
    setUpdatedata(false);
    Navigate("/statusDrone");
  };
  const register = (doc_save) => {
    AuthService.registerdrone(
      droneserial,
      brand,
      model,
      install_eq,
      remote_sn,
      remote_brand,
      ins_type,
      ins_number,
      ins_company_name,
      ins_limit,
      ins_start,
      ins_end,
      doc_save
    ).then(
      (Response) => {
        console.log(Response);
        Navigate("/statusDrone");
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  };

  useEffect(() => {
    const check = AuthService.getCurrentUser();
    if (check != null)
      check.then(function (result) {
        if (result.data.code === "GDS") {
          //console.log("passPIS");

          const data1 = AuthService.getCurrentUser().then(function (result) {
            setData(result.data.userdata);
            console.log(result);
          });
        } else {
          console.log("passGDSNS");
          setcheckuserdata(true);
          setTimeout((e) => {
            setcheckuserdata(false);
            Navigate("/editprofileuser");
          }, 3000);

          const data1 = AuthService.getCurrentUser().then(function (result) {
            setData(result.data.userdata);
            //console.log(result)
          });
        }
      });
  }, [Navigate]);
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    console.log(form);
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    event.preventDefault();
    setValidated(true);
  };
  return (
    <div //style={{background:"#E6E8EA",backgroundSize: "cover",height:"100%"}}
    >
      <div className="container font-cen" style={{ color: "black" }}>
        <h2
          style={{
            color: "#0077B6",
            position: "absolute",
            width: "676px",
            height: "69px",
            left: "50px",
            top: "130px",
            fontStyle: "normal",
            fontWeight: "700",
            fontSize: "46px",
            lineHeight: "69px",
          }}
        >
          ขอใบขึ้นทะเบียนเครื่องวิทยุคมนาคม
        </h2>
        &nbsp;
        <div style={myStyle}>
          <h3
            style={{
              color: "#0077B6",
              position: "absolute",
              width: "876px",
              height: "69px",
              left: "50px",
              top: "260px",
              fontStyle: "normal",
              fontWeight: "400",
              fontSize: "39px",
              lineHeight: "69px",
            }}
          >
            ข้อมูลอากาศยานที่ควบคุมการบินจากภายนอก
          </h3>
          <div>
            <Form
              ref={form1}
              noValidate
              validated={validated} //onSubmit={(e)=>handleSubmit(e)}
            >
              <Row
                className="mb-3"
                style={{
                  position: "absolute",
                  top: "350px",
                  left: "150px",
                  width: "1608px",
                  fontSize: "28px",
                }}
              >
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    Serial Number<span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="กรอกเลข serial number"
                    
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px",
                      color:"black"
                      
                     
                    }}
                    value={droneserial}
                    onChange={(e) => {
                      setDroneserial(e.target.value);
                      //console.log(e.target.value);
                    }}
                  />
                </Form.Group>

                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    ตราอักษร<span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="ตราอักษร"
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px", color:"black"
                    }}
                    onChange={(e) => {
                      setBrand(e.target.value);
                    }}
                  />
                </Form.Group>

                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    รุ่น<span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="รุ่น"
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px", color:"black"
                    }}
                    onChange={(e) => {
                      setModel(e.target.value);
                    }}
                  />
                </Form.Group>
                {/* <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">NBTCID</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="NBTCID"
                    disabled
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      //border:"1px solid",
                      borderRadius: "10px",
                    }}
                  />
                </Form.Group> */}
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    อุปกรณ์ที่ติดตั้ง(ถ้ามีโปรดระบุ)/installed accessories
                  </Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="ใบพัด,battery,Camera"
                    //disabled
                    style={{
                      height: "81px",
                      //width: "1620px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px", color:"black"
                    }}
                    onChange={(e) => {
                      setInstall_eq(e.target.value);
                    }}
                  />
                </Form.Group>
              </Row>
              <Row
                className="mb-3"
                style={{
                  position: "absolute",
                  top: "750px",
                  left: "150px",
                  width: "1608px",
                  fontSize: "28px",
                }}
              >
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    แบรนด์อุปกรณ์ควบคุมการบิน
                    <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="Ex. DJI"
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px",
                    }}
                    onChange={(e) => {
                      setRemote_brand(e.target.value);
                    }}
                  />
                </Form.Group>

                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    หมายเลขประจำเครื่องอุปกรณ์ควบคุมการบิน
                    <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="584819851841"
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px", color:"black"
                    }}
                    onChange={(e) => {
                      setRemote_sn(e.target.value);
                    }}
                  />
                </Form.Group>
              </Row>
              <Row
                className="mb-3"
                style={{
                  position: "absolute",
                  top: "970px",
                  left: "150px",
                  width: "1608px",
                  fontSize: "28px",
                }}
              >
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    ประเภทกรมธรรม์<span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder=""
                    //disabled
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px",
                    }}
                    onChange={(e) => {
                      setIns_type(e.target.value);
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    เลขกรมธรรม์<span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder=""
                    //disabled
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px", color:"black"
                    }}
                    onChange={(e) => {
                      setIns_number(e.target.value);
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    ชื่อบริษัทประกัน<span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder=""
                    //disabled
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px", color:"black"
                    }}
                    onChange={(e) => {
                      setIns_company_name(e.target.value);
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    วงเงินประกัน(ประกันภัยบุคคลที่ 3 วงเงินไม่ต่ำกว่า1ล้านบาท)
                    <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    min={1000000}
                    type="number"
                    placeholder=""
                    //disabled
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px", color:"black"
                    }}
                    onChange={(e) => {
                      setIns_limit(parseInt(e.target.value));
                    }}
                  />
                  <Form.Control.Feedback type="invalid">
                    กรุณาใส่จำนวนวงเงินตั้งแต่ 1,000,000 บาทค่ะ
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    ระยะเวลาเริ่มประกัน<span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    type="date"
                    placeholder=""
                    //disabled
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px", color:"black"
                    }}
                    value={ins_start}
                    onChange={(e) => {
                      setIns_start(e.target.value);
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    ระยะเวลาสิ้นสุดประกัน<span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    type="date"
                    placeholder=""
                    //disabled
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px", color:"black"
                    }}
                    value={ins_end}
                    onChange={(e) => {
                      setIns_end(e.target.value);
                      console.log(e.target.value);
                    }}
                  />
                </Form.Group>
              </Row>
              <Row
                style={{
                  position: "absolute",
                  top: "1500px",
                  left: "150px",
                  width: "1608px",
                  fontSize: "28px",
                }}
              >
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">คำนำหน้าชื่อ</Form.Label>

                  <Form.Control
                    disabled
                    value={data.title}
                    style={{
                      //width: "100%",
                      height: "81px",
                      fontSize: "28px",
                      borderRadius: "10px",color:"black"
                    }}
                  ></Form.Control>
                </Form.Group>

                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">ชื่อ</Form.Label>
                  <Form.Control
                    required
                    disabled={disabless}
                    type="text"
                    value={data.f_name}
                    style={{
                      height: "81px",
                      //width: "100%",
                      fontSize: "28px",
                      borderRadius: "10px", color:"black"
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">นามสกุล</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="text"
                    value={data.l_name}
                    style={{
                      height: "81px",
                      //width: "100%",
                      fontSize: "28px",
                      borderRadius: "10px", color:"black"
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="12">
                  <Form.Label className="font-cen">เลขบัตรประชาชน</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="number"
                    //value="1-2345-12345-12-3"
                    value={data.idnum}
                    style={{
                      height: "81px",
                      //width: "1621px",
                      fontSize: "28px",
                      borderRadius: "10px", color:"black"
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">อีเมล</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="email"
                    //value="name@example.com"
                    value={data.email}
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      borderRadius: "10px", color:"black"
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">เบอร์โทรศัพท์</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="number"
                    aria-label="Amount (to the nearest dollar)"
                    value={data.phone}
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      borderRadius: "10px", color:"black"
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="3">
                  <Form.Label className="font-cen">
                    วัน-เดือน-ปี เกิด
                  </Form.Label>
                  <Form.Control
                    disabled={disabless}
                    //type="date"
                    value={data.date_of_birth}
                    style={{
                      height: "81px",
                      //width: "345px",
                      fontSize: "28px",
                      borderRadius: "10px", color:"black"
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="3">
                  <Form.Label className="font-cen">อายุ</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="number"
                    value={data.age}
                    style={{
                      height: "81px",
                      //width: "345px",
                      fontSize: "28px",
                      borderRadius: "10px", color:"black"
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="3">
                  <Form.Label className="font-cen">เชื้อชาติ</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="text"
                    value={data.nationality}
                    style={{
                      height: "81px",
                      //width: "345px",
                      fontSize: "28px",
                      borderRadius: "10px", color:"black"
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="3">
                  <Form.Label className="font-cen">สัญชาติ</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="text"
                    value={data.nationality}
                    style={{
                      height: "81px",
                      //width: "345px",
                      fontSize: "28px",
                      borderRadius: "10px", color:"black"
                    }}
                  />
                </Form.Group>
              </Row>
              <Row
                className="mb-3"
                style={{
                  position: "absolute",
                  top: "2170px",
                  left: "150px",
                  width: "1608px",
                  fontSize: "28px",
                }}
              >
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    ที่อยู่(เลขที่, หมู่ที่, อาคาร, หมู่บ้าน, ซอย, ถนน)
                  </Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="text"
                    value={data.address}
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      borderRadius: "10px", color:"black"
                    }}
                  />
                </Form.Group>

                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">จังหวัด</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="text"
                    value={data.province}
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      borderRadius: "10px", color:"black"
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">ตำบล</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="text"
                    value={data.sub_dis}
                    style={{
                      height: "81px",
                      //width: "483px",
                      fontSize: "28px",
                      borderRadius: "10px", color:"black"
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">อำเภอ</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="text"
                    value={data.dis}
                    style={{
                      height: "81px",
                      //width: "483px",
                      fontSize: "28px",
                      borderRadius: "10px", color:"black"
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">รหัสไปรษณีย์</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="number"
                    value={data.pos_code}
                    style={{
                      height: "81px",
                      //width: "486px",
                      fontSize: "28px",
                      borderRadius: "10px", color:"black"
                    }}
                  />
                </Form.Group>
              </Row>
              <Row
                className="mb-3"
                style={{
                  position: "absolute",
                  top: "2570px",
                  left: "150px",
                  width: "1608px",
                  fontSize: "28px",
                }}
              >
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    ที่อยู่(เลขที่, หมู่ที่, อาคาร, หมู่บ้าน, ซอย, ถนน)
                  </Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="text"
                    value={data.cur_address}
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      borderRadius: "10px", color:"black"
                    }}
                  />
                </Form.Group>

                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">จังหวัด</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="text"
                    value={data.cur_province}
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      borderRadius: "10px", color:"black"
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">ตำบล</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="text"
                    value={data.cur_sub_dis}
                    style={{
                      height: "81px",
                      //width: "483px",
                      fontSize: "28px",
                      borderRadius: "10px", color:"black"
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">อำเภอ</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="text"
                    value={data.cur_dis}
                    style={{
                      height: "81px",
                      //width: "483px",
                      fontSize: "28px",
                      borderRadius: "10px", color:"black"
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">รหัสไปรษณีย์</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="number"
                    value={data.cur_poscode}
                    style={{
                      height: "81px",
                      //width: "486px",
                      fontSize: "28px",
                      borderRadius: "10px", color:"black"
                    }}
                  />
                </Form.Group>
              </Row>
              <Row
                className="mb-3"
                style={{
                  position: "absolute",
                  top: "2950px",
                  left: "150px",
                  width: "1608px",
                  fontSize: "28px",
                }}
              >
                <Form.Group as={Col} md="12">
                  <Form.Label className="font-cen">
                    สำเนาบัตรประจำตัวประชาชน
                  </Form.Label>
                  <Form.Control
                    required
                    name="file1"
                    type="file"
                    //disabled={disabless}
                    style={{
                      height: "81px",
                      //width: "1609px",
                      fontSize: "28px",
                      borderRadius: "10px", color:"black"
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="12">
                  <Form.Label className="font-cen">
                    หนังสือรับรองตนเอง
                  </Form.Label>
                  <Form.Control
                    required
                    type="file"
                    name="file2"
                    //disabled
                    style={{
                      height: "81px",
                      //width: "1609px",
                      fontSize: "28px",
                      borderRadius: "10px", color:"black"
                    }}
                  />
                </Form.Group>
              </Row>
              <div
                className="build-button-border"
                style={{
                  position: "absolute",
                  top: "3270px",
                  left: "1190px",
                  width: "226px",
                  height: "87px",
                  borderRadius: "27px",
                }}
              >
                <button
                  onClick={handleUpdate}
                  id="1"
                  //type="submit"
                  className="buildbutton"
                  style={{
                    position: "absolute",
                    width: "220px",
                    height: "82px",
                    //background: "white",
                    borderRadius: "27px",
                    fontSize: "31px",
                    // boxSizing: "border-box",
                    //borderColor: "linear-gradient(101.27deg, #E01E37 0%, #FF792B 100%)",
                    borderWidth: "0px",
                    borderStyle: "solid",
                  }}
                >
                  บันทึกข้อมูล
                </button>
              </div>
              &nbsp;
              <button
                onClick={handleSend}
                style={{
                  color: "white",
                  position: "absolute",
                  top: "3270px",
                  left: "1505px",
                  width: "220px",
                  height: "87px",
                  background:
                    "linear-gradient(101.27deg, #023E8A 0%, #0096C7 100%)",
                  borderRadius: "27px",
                  fontSize: "31px",
                  borderWidth: "0px",
                  borderStyle: "solid",
                }}
              >
                นำส่งข้อมูล
              </button>
            </Form>
            <Row>
              <h3
                as={Col}
                style={{
                  color: "#0077B6",
                  position: "absolute",
                  width: "876px",
                  height: "69px",
                  left: "50px",
                  top: "660px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  fontSize: "39px",
                  lineHeight: "69px",
                }}
              >
                ข้อมูลอุปกรณ์ควบคุมการบิน
              </h3>
            </Row>
            <Row>
              <h3
                as={Col}
                style={{
                  color: "#0077B6",
                  position: "absolute",
                  width: "876px",
                  height: "69px",
                  left: "50px",
                  top: "900px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  fontSize: "39px",
                  lineHeight: "69px",
                }}
              >
                เอกสารการประกันภัย
              </h3>
            </Row>
            <Row>
              <h3
                as={Col}
                style={{
                  color: "#0077B6",
                  position: "absolute",
                  width: "876px",
                  height: "69px",
                  left: "50px",
                  top: "1410px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  fontSize: "39px",
                  lineHeight: "69px",
                }}
              >
                ข้อมูลผู้ขอขึ้นทะเบียน
              </h3>

              <Button
                onClick={editdrone}
                //disabled={!disabless}
                style={{
                  color: "black",
                  textAlign: "center",
                  position: "absolute",
                  width: "124px",
                  height: "49px",
                  left: "400px",
                  top: "1420px",
                  fontWeight: "400px",
                  lineHeight: "58px",
                  fontSize: "39px",
                  background:
                    "linear-gradient(97.29deg, #FDC43F 0%, #FCEC5D 100%)",
                  borderRadius: "79px",

                  borderWidth: "0px",
                  borderStyle: "solid",
                }}
              >
                <h4>แก้ไข</h4>
              </Button>
            </Row>
            &nbsp;
            <Row>
              <h3
                style={{
                  color: "#0077B6",
                  position: "absolute",
                  width: "876px",
                  height: "69px",
                  left: "50px",
                  top: "2080px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  fontSize: "39px",
                  lineHeight: "69px",
                }}
              >
                ที่อยู่ตามบัตรประชาชนหรือทะเบียนบ้าน
              </h3>
            </Row>
            &nbsp;
            <Row>
              <h3
                style={{
                  color: "#0077B6",
                  position: "absolute",
                  width: "876px",
                  height: "69px",
                  left: "50px",
                  top: "2480px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  fontSize: "39px",
                  lineHeight: "69px",
                }}
              >
                ที่อยู่ปัจจุบัน
              </h3>
            </Row>
            &nbsp;
            <h3
              style={{
                color: "#0077B6",
                position: "absolute",
                width: "876px",
                height: "69px",
                left: "50px",
                top: "2880px",
                fontStyle: "normal",
                fontWeight: "400",
                fontSize: "39px",
                lineHeight: "69px",
              }}
            >
              เอกสารที่นำส่ง
            </h3>
            <Form noValidate onSubmit={handleSubmit}>
              <Modal
                show={updatedata}
                onHide={handleClose}
                className="font-cen"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>บันทึกข้อมูล</Modal.Title>
                </Modal.Header>
                <Modal.Body>ข้อมูลส่วนตัวจะถูกบันทึกใหม่</Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    ยกเลิก
                  </Button>
                  <Button variant="primary" onClick={handleUpdatesuc}>
                    ยืนยัน
                  </Button>
                </Modal.Footer>
              </Modal>
              <Modal
                show={updatedatasuc}
                onHide={handleClose}
                className="font-cen"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>บันทึกข้อมูลสำเร็จ</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <img
                    src={check}
                    style={{
                      width: "100px",
                      height: "100px",
                      padding: "3%",
                      marginLeft: "180px",
                    }}
                  />
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    ยกเลิก
                  </Button>
                </Modal.Footer>
              </Modal>
              <Modal
                show={show}
                onHide={handleClose}
                className="font-cen"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>นำส่งข้อมูลการขอขึ้นทะเบียน</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  ข้อมูลส่วนตัวจะถูกบันทึกใหม่และนำส่งข้อมูลการขอขึ้นทะเบียน
                  Drone
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    ยกเลิก
                  </Button>
                  <Button variant="primary" onClick={handleSendsuc}>
                    นำส่งข้อมูล
                  </Button>
                </Modal.Footer>
              </Modal>
              <Modal
                show={senddata}
                onHide={handleClose}
                className="font-cen"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>นำส่งข้อมูลสำเร็จ</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <img
                    alt="check"
                    src={check}
                    style={{
                      width: "100px",
                      height: "100px",
                      padding: "3%",
                      marginLeft: "180px",
                    }}
                  />
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    ปิด
                  </Button>
                  <Button variant="primary" onClick={next}>
                    ดูสถานะ
                  </Button>
                </Modal.Footer>
              </Modal>
              <Modal
                show={checkuserdata}
                centered
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                className="font-cen"
                //style={{ color: "red", background: "rgba(0,0,0,0.9)" }}
              >
                <Modal.Body
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    //background: "black",
                  }}
                >
                  <h3 className="visually-hidden">no user data</h3>
                </Modal.Body>
              </Modal>
            </Form>
            &nbsp;
          </div>
        </div>
      </div>
    </div>
  );
}
export default EditRegisDrone;
